import { memo, Suspense, useCallback } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PrivatePage } from './PrivatePage';
import { routeConfig } from '../config/routeConfig';
import { AppRoutesProps } from '@shared/types/router';
import { PreloaderCircular } from '@shared/ui/kit';

export const AppRouter = memo(() => {
  const renderWithWrapper = useCallback((route: AppRoutesProps) => {
    const content = <Suspense fallback={<PreloaderCircular />}>{route.element}</Suspense>;

    const element = route.layout ? <route.layout>{content}</route.layout> : content;

    return (
      <Route
        key={route.path}
        path={route.path}
        element={route.authOnly ? <PrivatePage>{element}</PrivatePage> : element}
      />
    );
  }, []);

  return <Routes>{Object.values(routeConfig).map(renderWithWrapper)}</Routes>;
});
